import BrButton from '@govbr/react-components/lib/BrButton';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import imgFundo from '../../assets/img/como-cadastrar-fundo.svg';
import imgPagina1 from '../../assets/img/como-cadastrar-pagina1.svg';
import imgMoca1 from '../../assets/img/como-cadastrar-moca1.svg';
import imgPagina2 from '../../assets/img/como-cadastrar-pagina2.svg';
import imgMoca2 from '../../assets/img/como-cadastrar-moca2.svg';
import imgPagina3 from '../../assets/img/como-cadastrar-pagina3.svg';
import imgPagina4 from '../../assets/img/como-cadastrar-pagina4.svg';
import imgMoca3 from '../../assets/img/como-cadastrar-moca3.svg';
import Card from '../../components/Card/Card';
import styles from './ComoAtualizar.module.css';

const ComoAtualizar: React.FC<any> = () => {
  const history = useHistory();

  const [page, setPage] = useState(1);

  const pagina1 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Para atualizar o cadastro</div>
          <i className={`fas fa-times ${styles.close}`} onClick={() => history.goBack()}/>
        </div>
        <div className={`${styles.content} ${styles.start}`}>
          <Card className={styles.card1}>
            <span>
              É preciso que o(a) <strong>Responsável Familiar (RF)</strong> ou o
              <strong> Representante Legal (RL)</strong> procure um posto de
              atendimento do Cadastro Único no município onde a família mora. O cadastro deve ser
              atualizado pelo menos a cada <strong>dois anos</strong>.
              Manter os dados atualizados permite que as famílias participem dos
              programas sociais do Governo Federal e não percam benefícios que já recebam.
            </span>
          </Card>
          <img className={styles.imgPagina1} src={imgPagina1} alt="Imagem do rodapé" />
          <img className={styles.imgMoca1} src={imgMoca1} alt="Mulher em pé" />
        </div>
        <div className={styles.footer}>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(2)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <img className={styles.imgFundo} src={imgFundo} alt="Imagem de fundo" />
      </div>
    </div>
  );

  const pagina2 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Para atualizar o cadastro</div>
          <i className={`fas fa-times ${styles.close}`} onClick={() => history.goBack()}/>
        </div>
        <div className={styles.content}>
          <Card className={styles.card2}>
            <span>
              O(a) <strong>Responsável Familiar (RF)</strong> é a pessoa da família que prestou as
              informações de todos os integrantes da família para o entrevistador do Cadastro Único.
              Agora ele(a) deverá voltar ao <strong>posto de atendimento</strong> para atualizar os
              dados.
            </span>
          </Card>
          <Card className={`${styles.card2} ${styles.secondary}`}>
            <span>
              Se a família foi cadastrada por um <strong>Representante Legal (RL)</strong>, ele(a)
              deverá fazer a atualização dos dados diretamente em um posto de atendimento do Cadastro Único.
              O(a) Representante Legal (RL) é um tutor,
              curador ou guardião responsável por pessoas sem família, como crianças ou adolescentes
              menores de 16 anos ou adultos incapazes que vivem em instituições de acolhimento.
            </span>
          </Card>
          <img className={styles.imgPagina2} src={imgPagina2} alt="Imagem do rodapé" />
          <img className={styles.imgMoca2} src={imgMoca2} alt="Mulher em pé" />
        </div>
        <div className={styles.footer}>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(3)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(2)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <img className={styles.imgFundo} src={imgFundo} alt="Imagem de fundo" />
      </div>
    </div>
  );

  const pagina3 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Documentos necessários</div>
          <i className={`fas fa-times ${styles.close}`} onClick={() => history.goBack()}/>
        </div>
        <div className={styles.content}>
          <Card className={styles.card2}>
            <div className="fs16">
              <strong>Responsável Familiar (RF)</strong>
            </div>
            <ul className={styles.bulletList}>
              <li>CPF; ou </li>
              <li>Título de Eleitor</li>
            </ul>
            <div>
              <strong>Outras pessoas da família (pelo menos um desses documentos):</strong>
            </div>
            <ul className={styles.bulletList}>
              <li>CPF;</li>
              <li>Título de eleitor;</li>
              <li>Certidão de nascimento;</li>
              <li>Certidão de casamento;</li>
              <li>Carteira de identidade (RG); ou</li>
              <li>Carteira de trabalho.</li>
            </ul>
          </Card>
          <Card className={`${styles.card2} ${styles.secondary}`}>
            <div className="fs16">
              <strong>Representante Legal (RL)</strong>
            </div>
            <ul className={styles.bulletList}>
              <li>CPF; e</li>
              <li>Termo de guarda, tutela e curatela de quem será cadastrado.</li>
            </ul>
          </Card>
          <img className={styles.imgPagina3} src={imgPagina3} alt="Imagem do rodapé" />
          <img className={styles.imgMoca3} src={imgMoca1} alt="Mulher em pé" />
        </div>
        <div className={styles.footer}>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(4)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(3)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <img className={styles.imgFundo} src={imgFundo} alt="Imagem de fundo" />
      </div>
    </div>
  );

  const pagina4 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Postos de atendimento</div>
          <i className={`fas fa-times ${styles.close}`} onClick={() => history.goBack()} />
        </div>
        <div className={styles.content}>
          <Card className={styles.card4}>
            <span>
              O(a) <strong>Responsável Familiar (RF)</strong> ou o(a){' '}
              <strong>Representante Legal (RL)</strong> deve ir ao posto de atendimento do Cadastro
              Único levando os <strong>documentos das pessoas da família.</strong>
              <br />
              <br />
              Esses postos normalmente funcionam nos Centros de Referência da Assistência Social (
              <strong>CRAS</strong>) ou nas sedes da secretaria de assistência social da{' '}
              <strong>prefeitura.</strong>
              <br />
              <br />
              Você pode buscar onde ficam os postos de atendimento <strong>mais próximos</strong> de
              você na opção{' '}
              <span className={styles.link} onClick={() => history.replace('/posto-atendimento')}>
                POSTOS DE ATENDIMENTO
              </span>
              .
            </span>
          </Card>
          <img className={styles.imgPagina4} src={imgPagina4} alt="Imagem do rodapé" />
          <img className={styles.imgMoca4} src={imgMoca3} alt="Mulher em pé" />
        </div>
        <div className={styles.footer}>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => history.goBack()}>
              Concluir
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(4)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
            </div>
          </div>
        </div>
        <img className={styles.imgFundo} src={imgFundo} alt="Imagem de fundo" />
      </div>
    </div>
  );

  return (
    <>
      {page === 1 && pagina1}
      {page === 2 && pagina2}
      {page === 3 && pagina3}
      {page === 4 && pagina4}
    </>
  );
};

export default ComoAtualizar;
